 <template>

   <!--系统维护中-->
   <div class="P400">
     <div class="not-found">
       <img src="../assets/system_01.png" alt="" style="width: 50%;">
     </div>
   </div>


</template>

 <script>

   import { mapState, mapMutations } from 'vuex'

   import wxConfirm from '@/wechat-messagebox/Confirm'
   import D from '@/wc-messagebox'
   import Vue from 'vue'
   Vue.use(D)

   export default {
     data(){
       return{
         res: {}
       }
     },
     computed: {

     },
     created() {
       this.$loading.hide();
     },
     methods: {

     },
     components: {

     },

   }

 </script>


<style scoped>
  .P400{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 9999; width: 100%; height: 100%; background-color: #fff; }
  .not-found{ padding-top: 30%; margin: 0 auto; text-align: center;  }
  .not-found img{ width: 60%; height: auto;  }
  .not-found p{margin-top:.2rem; font-size: .3rem; color: #999; line-height: .4rem;  }
</style>



// WEBPACK FOOTER //
// src/components/P400.vue